<template>
  <div class="date-filter">
    <div class="level">
      <div class="level-left">
        <div class="level-item is-italic">
          Filter:
        </div>
        <div class="level-item">
          Laat alleen de data zien uit de periode van
        </div>
        <div class="level-item">
          <datepicker v-model="startDate" :config="{ wrap: true }" readonly>
          </datepicker>
        </div>
        <div class="level-item">
          tot
        </div>
        <div class="level-item">
          <datepicker v-model="endDate" :config="{ wrap: true }" readonly>
          </datepicker>
        </div>
        <div class="level-item">
          <button
            class="button is-link is-outlined"
            v-on:click="modal = !modal"
          >
            <span class="icon is-small">
              <i class="fas fa-heart"></i>
            </span>
          </button>
          <button
            class="button is-danger is-outlined"
            :disabled="isDefaultRange"
            v-on:click="onResetDateFilter"
          >
            <span class="icon is-small">
              <i class="fas fa-undo"></i>
            </span>
          </button>
          <!-- Modal for saving preset -->
          <div class="modal" v-bind:class="{ 'is-active': modal }">
            <div class="modal-background" v-on:click="modal = !modal"></div>
            <div class="modal-content">
              <div class="box">
                <!-- Any other Bulma elements you want -->
                <input
                  class="input"
                  type="text"
                  v-model="presetname"
                  placeholder="Naam periode"
                />
                <a class="button is-link is-outlined" @click="savePeriod"
                  >Opslaan</a
                >
              </div>
            </div>
          </div>
        </div>
        <Indicators v-on:onSelectedPreset="onSelectedPreset" />
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vue-bulma-datepicker";
import moment from "moment";
import Indicators from "./../Indicators/IndicatorList";

export default {
  name: "DateFilter",
  data() {
    return {
      modal: false,
      presetname: "",
      defaultEndDate: moment().format("YYYY-MM-DD"),
      defaultStartDate: moment()
        .subtract(7, "days")
        .format("YYYY-MM-DD"),
      maxDateDiff: 21
    };
  },
  components: {
    Datepicker,
    Indicators
  },
  computed: {
    startDate: {
      get() {
        return this.$store.getters.dataFilterStartDate;
      },
      set(value) {
        this.$store.commit("setDateFilterStartDate", value);
        const startD = moment(value);
        const endD = moment(this.$store.getters.dataFilterEndDate);
        const diff = endD.diff(startD, "days", true);
        if (diff > this.maxDateDiff) {
          let endDate = moment(this.startDate)
            .add(this.maxDateDiff, "days")
            .format("YYYY-MM-DD");
          this.$store.commit("setDateFilterEndDate", endDate);
        } else if (diff < 1) {
          let endDate = moment(this.startDate)
            .add(1, "days")
            .format("YYYY-MM-DD");
          this.$store.commit("setDateFilterEndDate", endDate);
        }
      }
    },
    endDate: {
      get() {
        return this.$store.getters.dataFilterEndDate;
      },
      set(value) {
        this.$store.commit("setDateFilterEndDate", value);
        const startD = moment(this.$store.getters.dataFilterStartDate);
        const endD = moment(value);
        const diff = endD.diff(startD, "days", true);
        if (diff > this.maxDateDiff) {
          let startDate = moment(this.endDate)
            .subtract(this.maxDateDiff, "days")
            .format("YYYY-MM-DD");
          this.$store.commit("setDateFilterStartDate", startDate);
        } else if (diff < 1) {
          let startDate = moment(this.endDate)
            .subtract(1, "days")
            .format("YYYY-MM-DD");
          this.$store.commit("setDateFilterStartDate", startDate);
        }
      }
    },
    isDefaultRange() {
      let isDefaultEndDate =
        this.defaultEndDate === this.$store.getters.dataFilterEndDate;
      let isDefaultStartDate =
        this.defaultStartDate === this.$store.getters.dataFilterStartDate;
      return isDefaultEndDate && isDefaultStartDate;
    }
  },
  methods: {
    onSelectedPreset(options) {
      // eslint-disable-next-line
      console.log("datefilter", options);
      this.$emit("onSelectedPreset", options);
    },
    onResetDateFilter() {
      this.endDate = this.defaultEndDate;
      this.startDate = this.defaultStartDate;
    },
    savePeriod() {
      this.modal = false;
      let location = this.$store.getters.navigationActiveTab.name;
      let payload = {
        name: this.presetname,
        startDate: this.startDate,
        endDate: this.endDate,
        location: location
      };
      this.$store.dispatch("appendUserPresets", payload);
      this.presetname = "";
    },
    updateDates() {
      let location = this.$store.getters.navigationActiveTab.name;
      this.$store.dispatch("fetchWeather", { location: location });
    }
  }
};
</script>

<style scoped>
.level-left .level-item:first-child {
  padding-left: 12px;
}
.level-right .level-item:first-child {
  padding-right: 12px;
}
.flatpickr {
  width: 110px;
}
.level-item button {
  margin-right: 10px;
}
</style>
